const QuestionList = [
  {
    index: 0,
    type: 'multi',
    question: '1：陪玩師是誰？（多選）',
    options: [
      {
        id: 'A',
        text: '遊戲高手，帶人體驗電競快感',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'B',
        text: '聲甜幽默，陪伴消磨無聊時間',
        isSelected: false
      },
      {
        id: 'C',
        text: '歌聲動人，給人帶來聽覺享受',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'D',
        text: '塔羅、星座、情感、提醒、繪圖…人盡其才必有我用。',
        isSelected: false,
        isCorrectAnswer: true
      }
    ],
    userAnswer: [],
    answer: ['A', 'B', 'C', 'D']
  },
  {
    index: 1,
    type: 'multi',
    question: '2：如何賺錢？（多選）',
    options: [
      {
        id: 'A',
        text: '創建有吸引力的技能介紹',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'B',
        text: '在約單大廳積極搶單',
        isSelected: false
      },
      {
        id: 'C',
        text: '在動態廣場發佈吸引人的內容推廣自己',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'D',
        text: '在遊戲或社交媒介中展示自己，並帶上Nicee暱稱，便於人查找',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'E',
        text: '維護好已有客戶，主動提供關心，創造可持續的服務',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'F',
        text: '樂觀心態，職業態度',
        isSelected: false,
        isCorrectAnswer: true
      }
    ],
    userAnswer: [],
    answer: ['A', 'B', 'C', 'D', 'E', 'F']
  },
  {
    index: 2,
    type: 'multi',
    question: '3：怎樣提領收入？（多選）',
    options: [
      {
        id: 'A',
        text: '實名身份',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'B',
        text: '耐心等待系統結算入賬',
        isSelected: false
      },
      {
        id: 'C',
        text: '綁定收款銀行賬戶',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'D',
        text: '催促客服加快提領',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'E',
        text: '出現存疑款項時與客服消極溝通',
        isSelected: false,
        isCorrectAnswer: true
      }
    ],
    userAnswer: [],
    answer: ['A', 'B', 'C']
  },
  {
    index: 3,
    type: 'multi',
    question: '4：怎樣保護自己？（多選）',
    options: [
      {
        id: 'A',
        text: '對於大額訂單，切記確保交易內容、聊天記錄留底可查',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'B',
        text: '如發現非法的用戶，積極檢舉，維護平台與其他陪玩師的安全',
        isSelected: false
      },
      {
        id: 'C',
        text: '出現糾紛、爭議，主動與客服聯繫，尋求解決',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'D',
        text: '不尊重用戶隱私，將客戶聊天截圖直接公佈到廣場',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'E',
        text: '通過網路人肉，線下圍堵他人',
        isSelected: false,
        isCorrectAnswer: true
      }
    ],
    userAnswer: [],
    answer: ['A', 'B', 'C']
  },
  {
    index: 4,
    type: 'multi',
    question: '5：哪些行為平台嚴令禁止並會嚴厲處罰？（多選）',
    options: [
      {
        id: 'A',
        text: '發佈無關遊戲或服務的內容',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'B',
        text: '詐騙',
        isSelected: false
      },
      {
        id: 'C',
        text: '對他人進行人身攻擊',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'D',
        text: '與非法金融團伙合作洗錢',
        isSelected: false,
        isCorrectAnswer: true
      }
    ],
    userAnswer: [],
    answer: ['B', 'C', 'D']
  },
  {
    index: 5,
    type: 'multi',
    question: '6：作為新人，怎樣開始第一步？（多選）',
    options: [
      {
        id: 'A',
        text: '發超多超美自拍',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'B',
        text: '發超多超厲害的遊戲戰績、視頻',
        isSelected: false
      },
      {
        id: 'C',
        text: '將IG、Tiktok、Twitch、Youtube個人頁放入介紹便於了解',
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'D',
        text: '積極搶單',
        isSelected: false,
        isCorrectAnswer: true
      }
    ],
    userAnswer: [],
    answer: ['A', 'B', 'C', 'D']
  }
];

export default QuestionList;
